import { FaFilter } from 'react-icons/fa';
import styled from 'styled-components';

import { inputIconStyle } from 'components/Search/Search.style';

export const FilterIcon = styled(FaFilter)`
  ${inputIconStyle}
`;
export const FilterContainer = styled.div`
  width: 100%;
  max-width: 20rem;
  margin-left: 1px;
  margin-bottom: 1rem;
  position: relative;

  /* Match TableSearchHeader / memory list search styling (rounded pill, consistent look) */
  input {
    border-radius: 34px;
    max-height: 33px;
    min-width: 250px;
    padding-left: 3.8rem;

    &::placeholder {
      color: ${(props) => props.theme.gray};
    }
  }
`;
